<template>
  <span v-if="bookingStatus == 'PENDING'" class="badge badge-info py-1 px-2">Beklemede</span>
  <span v-else-if="bookingStatus == 'OK' || bookingStatus == 'SUCCESS'" class="badge badge-success py-1 px-2">Onaylandı</span>
  <span v-else-if="bookingStatus == 'OK' || bookingStatus == 'SUCCESS' || bookingStatus == 'COMPLIMENTARY'" class="badge badge-success py-1 px-2"
        style="background-color: #0d47a1"
  >Ücretsiz</span>

  <span v-else-if="bookingStatus == 'PARTIALLY_PAID'" class="badge badge-info py-1 px-2">Parçalı Ödeme</span>
  <span v-else-if="bookingStatus == 'CANCELLED'" class="badge badge-warning py-1 px-2">İptal</span>
  <span v-else-if="bookingStatus == 'NO_SHOW'" class="badge badge-warning py-1 px-2">No Show</span>
  <span v-else-if="bookingStatus == 'FAILED'" class="badge badge-warning py-1 px-2">Başarısız</span>

  <span v-else-if="bookingStatus == 'CREDIT_CARD'" class="badge badge-info py-1 px-2">Kredi Kartı</span>
  <span v-else-if="bookingStatus == 'COUPON'" class="badge badge-warning py-1 px-2">Kupon</span>
  <span  v-else class="badge badge-light py-1 px-2">{{ bookingStatus }}</span>
</template>

<script>
export default {
  name: "reservationStatus",
  props:{
    bookingStatus:String
  }
}
</script>

<style scoped>

</style>